export const LANDING_CONFIG = {
    7: 'LandingViewVP7',
    971: 'LandingViewVP7_1',
    8: 'LandingViewVP8',
    9: 'LandingViewVP9',
    12: 'LandingViewVP12'
}

export const LANDING_CONTENT_CONFIG = {
    7: 'landing_v7',
    971: 'landing_v7_1',
    8: 'landing_v8',
    9: 'landing_v9',
    12: 'landing_v12',
    default: 'landing_v7'
}

export const LANDINGS_EMAIL_CONTENT = {
    landing_ios_v1: 'ios_v1',
    landing_ios_v2: 'ios_v2',
    landing_ios_v3: 'ios_v3',
    landing_ios_v4: 'ios_v4',
    landing_ios_v5: 'ios_v5',
    landing_android_v1: 'android_v1',
    landing_android_v2: 'android_v2',
    landing_android_v3: 'android_v3',
    landing_android_v4: 'android_v4',
    default: null
}
